import { render, staticRenderFns } from "./BCXNavigation.vue?vue&type=template&id=c7b090c4&scoped=true"
import script from "./BCXNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./BCXNavigation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BCXNavigation.vue?vue&type=style&index=0&id=c7b090c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b090c4",
  null
  
)

export default component.exports